import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import CardBody from '../../shared/components/CardBody';
import FormField from '../../shared/components/FormField';
import OutsourceTree from './OutsourceTree';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workActions from '../actions/workActions';
import * as companyActions from '../../company/actions/companyActions';
import * as schemaTypeActions from '../../documents/actions/schemaTypeActions';
import Alert from 'react-s-alert';
import DateUtils from '../../shared/utils/DateUtils';
import UserRole from '../../shared/model/UserRole';
import { FormSwitch } from '../../shared/components/FormSwitch';
import { CurrentUser } from '../../shared/model/CurrentUser';

class WorkFormCard extends React.Component {

    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillMount() {
        this.getWork();
        this.props.schemaTypeActions.getWorkDocumentSchemaState();
        this.props.schemaTypeActions.getWorkDocumentLinkSchemaState();
    }

    componentWillUnmount() {
        const { workActions } = this.props;
        workActions.clearWork();
    }

    getWork() {
        this.props.workActions.getWork(this.props.workId);
    }

    checkContracts(contracts) {
        let correct = true;
        if ( contracts ) {
            contracts.forEach((contract) => {
                correct = correct && contract.company && contract.company.id && contract.company.id !== -1;
                correct = correct && this.checkContracts(contract.children);
            });
        }
        return correct;
    }

    onSubmit(values) {
        // Todos los valores en "this.props.work" están en "values".

        const contractsChecked = this.checkContracts(values.contracts);

        if ( !contractsChecked ) {
            Alert.error(I18nUtils.tr('TR_SUBCONTRATAS_INCORRECTAS'));
        } else {
            const constructionSave = this.parserSubmit(values);
            this.props.workActions.updateWork(constructionSave);
        }
    }

    parserSubmit = (
        {
            code,
            // company_assigned,
            // construction_state,
            construction_state_id,
            // contractor,
            // contractors,
            // contracts,
            // document_schema,
            document_schema_id,
            // document_schema_link,
            document_schema_link_id,
            end_date,
            id,
            importation_id,
            name,
            notes,
            start_date,
            email_alerts,
        },
    ) => ( {
        id,
        name,
        code,
        start_date: DateUtils.buildDateFromString(start_date).toISOString(),
        end_date: DateUtils.buildDateFromString(end_date).toISOString(),
        notes,
        importation_id: importation_id ? Number(importation_id) : null,
        document_schema_id: document_schema_id && Number(document_schema_id) !== -1 ? Number(document_schema_id) : null,
        document_schema_link_id: document_schema_link_id && Number(document_schema_link_id) !== -1 ? Number(document_schema_link_id) : null,
        construction_state_id: !construction_state_id ? 2 : 1,
        company_id: null,
        contracts: this.props.work.contracts, // Por cómo está montado es necesario obtener los contracts de props
        email_alerts,
    } );

    onRefresh() {
        this.getWork();
    }

    renderField(field) {
        return <FormField field={field}/>;
    }

    renderHeaderOptions() {
        const moreOptions = [
            {
                title: I18nUtils.tr('TR_NUEVA_OBRA'),
                onClick: () => {
                    this.props.workActions.goToAddWork();
                },
            },
        ];
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                enableRefresh={true}
                enableSearch={false}
                moreOptions={moreOptions}
            />
        );
    }

    renderOutsourceTree() {
        const { work, user } = this.props;
        const noTree = !work || !user;
        if ( noTree ) return null;
        const roleId = user.roles[0].role.id;

        switch ( roleId ) {
            case UserRole.ADMIN:
            case UserRole.OUTSOURCES_MANAGER:
            case UserRole.CONTRACTORS_MANAGER:
                return (
                    <OutsourceTree
                        contracts={work.contracts}
                        allowAddContractToFirstLevel={true}
                        firstLevelCanRemoved={true}
                        showSeparators={false}
                    />
                );
            case UserRole.SUPERADMIN:
            case UserRole.OUTSOURCES_VIEWER:
                return null;
            default:
        }
    }

    render() {
        const {
            handleSubmit,
            currentUser,
        } = this.props;
        const enableEmailAlerts = currentUser.enableEmailAlerts();

        return (
            <Row clearfix>
                <Card loading={this.props.loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_FICHA_OBRA').toUpperCase()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody className={'table-responsive'}>
                        <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <Row>
                                <div className="col-md-6">
                                    <Row>
                                        <Field
                                            label={I18nUtils.tr('TR_CODIGO') + ':'}
                                            placeholder={I18nUtils.tr('TR_CODIGO')}
                                            name="code"
                                            type={'text'}
                                            colWidth="col-sm-6"
                                            component={this.renderField}
                                        />
                                        <Field
                                            col="col-sm-6"
                                            name="construction_state_id"
                                            label={I18nUtils.tr('TR_ESTADO')}
                                            labelEnabled={I18nUtils.tr('TR_ACTIVA')}
                                            labelDisabled={I18nUtils.tr('TR_INACTIVA')}
                                            component={FormSwitch}
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            label={I18nUtils.tr('TR_NOMBRE') + ':'}
                                            placeholder={I18nUtils.tr('TR_NOMBRE_DE_LA_OBRA')}
                                            name="name"
                                            type={'text'}
                                            colWidth="col-sm-9"
                                            component={this.renderField}
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            label={I18nUtils.tr('TR_FECHA_INICIO')}
                                            placeholder={I18nUtils.tr('TR_FECHA_INICIO')}
                                            name="start_date"
                                            type={'date'}
                                            colWidth="col-sm-6"
                                            component={this.renderField}
                                        />
                                        <Field
                                            label={I18nUtils.tr('TR_FECHA_FIN')}
                                            placeholder={I18nUtils.tr('TR_FECHA_FIN')}
                                            name="end_date"
                                            type={'date'}
                                            colWidth="col-sm-6"
                                            component={this.renderField}
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            label={I18nUtils.tr('TR_DESCRIPCION_DE_LA_OBRA')}
                                            placeholder=""
                                            name="notes"
                                            type={'textarea'}
                                            rows={2}
                                            colWidth="col-sm-12"
                                            component={this.renderField}
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            label={I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS') + ':'}
                                            name="document_schema_link_id"
                                            type={'selectSimple'}
                                            options={this.props.linkedDocumentsOptions}
                                            colWidth="col-sm-12"
                                            component={this.renderField}
                                        />
                                    </Row>
                                    {
                                        enableEmailAlerts &&
                                        <Row>
                                            <Field
                                                label={I18nUtils.tr('TR_EMAIL_PARA_AVISOS') + ':'}
                                                name="email_alerts"
                                                type={'email'}
                                                colWidth="col-sm-12"
                                                component={this.renderField}
                                            />
                                        </Row>
                                    }
                                </div>
                                <div className="col-md-6">
                                    {this.renderOutsourceTree()}
                                </div>
                            </Row>
                            <Row>
                                <div className="col-md-6"/>
                                <Field
                                    label={I18nUtils.tr('TR_CAMBIAR').toUpperCase()}
                                    name="submit"
                                    type={'submit'}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                />
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

function validate(values) {
    const errors = {};

    if ( !values.code ) {
        errors.code = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !DateUtils.isValidDate(values.start_date) ) {
        errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( !DateUtils.isValidDate(values.end_date) ) {
        errors.end_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( DateUtils.isValidDate(values.start_date) && DateUtils.isValidDate(values.end_date) ) {
        let startDate = values.start_date;
        if ( typeof startDate === 'string' ) {
            startDate = DateUtils.buildDateFromString(startDate);
        }
        let endDate = values.end_date;
        if ( typeof endDate === 'string' ) {
            endDate = DateUtils.buildDateFromString(endDate);
        }

        if ( startDate > endDate ) {
            errors.start_date = I18nUtils.tr('TR_FECHA_INICIO_NO_PUEDE_SER_MAYOR_QUE_FIN');
            // errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
        }
    }

    // if (!values.start_date) {
    //   errors.start_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.end_date) {
    //   errors.end_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.notes) {
    //   errors.notes = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.company_id || values.company_id === -1 || values.company_id === '-1') {
    //   errors.company_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }

    return errors;
}

WorkFormCard = reduxForm({
    validate,
    form: 'AddWorkForm',
})(WorkFormCard);

const mapStateToProps = (state, ownProps) => {

    const workSchemaOptions = state.schemaType.workDocumentSchemaType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    const linkedDocumentsOptions = state.schemaType.workDocumentSchemaLinkType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    const work = state.works.works[ownProps.workId];
    if ( work ) {
        if ( work.company_assigned ) work.company_id = work.company_assigned.id;
        if ( work.construction_state ) work.construction_state_id = work.construction_state.id === 1 ? 1 : 0;
        if ( work.document_schema ) work.document_schema_id = work.document_schema.id;
        if ( work.document_schema_link ) work.document_schema_link_id = work.document_schema_link.id;
        if ( work.start_date ) work.start_date = new Date(work.start_date);
        if ( work.end_date ) work.end_date = new Date(work.end_date);
    }

    return {
        user: state.auth.user,
        loading: state.works.workLoading,
        workSchemaOptions: workSchemaOptions,
        linkedDocumentsOptions: linkedDocumentsOptions,
        initialValues: work,
        work,
        currentUser: CurrentUser.fromReduxState(state),
    };
};

const mapDispatchToProps = dispatch => ( {
    workActions: bindActionCreators(workActions, dispatch),
    companyActions: bindActionCreators(companyActions, dispatch),
    schemaTypeActions: bindActionCreators(schemaTypeActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(WorkFormCard);

WorkFormCard.propTypes = {
    workId: PropTypes.string.isRequired,
};

WorkFormCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/works/components/WorkFormCard.jsx